"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _revalidate = require("revalidate");

var isValidState = (0, _revalidate.createValidator)(function (message) {
  return function (value, allValues) {
    if (!value && allValues["country"] === "IN") {
      return message;
    }
  };
}, function (field) {
  return field + " is required";
});
var validate = exports.validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: "This is who will be invoiced" }),
  postalCode: (0, _revalidate.isRequired)({ message: "Postal code is required" }),
  city: (0, _revalidate.isRequired)({ message: "City is required" }),
  country: (0, _revalidate.isRequired)({ message: "Country is required" })
  // state: isValidState({ message: "State is required" }),
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/addressSettingsFormValidation.js
// module id = 2822
// module chunks = 0